export const calculateSizes = (isSmall, isMobile, isTablet) => {
    return {
        computerDeskScale: isSmall ? 1.5 : isTablet ? 1.6 : 1.7,
        deskPosition: isMobile ? [0, -4, 0] : [0.25, -5, 0],
        ballPosition: isSmall ? [-9, -7, 0] : isMobile ? [-9, -7, 0] : isTablet ? [-9, -7, 0] : [-17, -5, 0],
        reactLogoPosition: isSmall ? [8, 4, 0] : isMobile ? [5, 4, 0] : isTablet ? [5, 4, 0] : [16, 1, 0],
        barcaLogoPosition: isSmall ? [-8, 5, 0] : isMobile ? [-5, 4, 0] : isTablet ? [-5, 4, 0] : [-17, 6, 0],
        barcaScale: isSmall ? 25 : isTablet ? 30 : 45,
        logoScale: isSmall ? 0.6 : isTablet ? 0.4 : 0.7,
        padPosition: isSmall ? [8, -3, 0] : isMobile ? [-1.5, -7, 0] : isTablet ? [8, -3, 0] : [16, -4, 0],
        padScale: isSmall ? 1.1 : isTablet ? 1 : 2,
        ballScale: isSmall ? 1.4 : isTablet ? 1.2 : 1.7
    };
};